import React, { memo, useState } from "react";
import HorizontalMenu from "components/HorizontalMenu";
import HistoryOrderItem from "./Components/HistoryOrderItem";

import { useHistory } from "react-router-dom";

const FormOrder = props => {
	const history = useHistory();
	const {
		listOrder,
		isMobile,
		fetchListOrder,
		setMenuChildrenHistory,
		menuChildren,
		business
	} = props;

	const [value, setValue] = useState(menuChildren);
	const divToScrollTo = document.getElementById("listHistoryOrder");
	const distanceToTop = divToScrollTo?.offsetTop;
	const height = `calc(100vh - ${distanceToTop}px)`;

	const handleSeeDetails = data => {
		const { business, id } = data;
		history.push(`/order_history_detail?id=${id}&business=${business}`);
	};

	const listMenu = [
		{
			label: "Đơn mua",
			code: "CRM",
			component: (
				<HistoryOrderItem
					listOrder={listOrder}
					isMobile={isMobile}
					heightBody={height}
					handleSeeDetails={handleSeeDetails}
					business={business}
				/>
			)
		},
		{
			label: "Từ NVBH",
			code: "SALEMAN_APP",
			component: (
				<HistoryOrderItem
					listOrder={listOrder}
					isMobile={isMobile}
					heightBody={height}
					handleSeeDetails={handleSeeDetails}
					business={business}
				/>
			)
		}
	];

	const handleChange = (event, newValue) => {
		setValue(newValue);
		setMenuChildrenHistory(newValue);
	};

	const handleHorizontalMenu = code => {
		fetchListOrder(code, "SALE");
	};

	return (
		<HorizontalMenu
			listMenu={listMenu}
			heightBody={height}
			handleHorizontalMenu={handleHorizontalMenu}
			value={value}
			handleChange={handleChange}
		/>
	);
};

export default memo(FormOrder);
